/**
 * @file 产品板块
 * @author Wence
 */

import {rcAjax} from '../util';
import {GET_CMSAPI_PRODUCT_LIST} from './ActionTypes';

export function fetchCmsapiProductList() {
    return function (dispatch) {
        return rcAjax('GET', '/cmsapi/productSegment', null, {}, res => {
            dispatch({type: GET_CMSAPI_PRODUCT_LIST, data: res.data && res.data.is_error === 0 ? res.data : {}});
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/productCenterAction.js